export enum CubeFilterDimensions {
  CONVERSATION_PLAYBOOK_ID = 'FACTDriftChatConversationV2.playbookId',
  CONVERSATION_PARTICIPANT_STATUS = 'FACTDriftChatConversationV2.participantStatus',
  CONVERSATION_CLASSIFICATION_ID = 'FACTDriftChatConversationV2.lastClassificationId',
  CONVERSATION_INBOX_ID = 'FACTDriftChatConversationV2.inboxId',
  CONVERSATION_TAG_NAME = 'DriftChatTags.name',
  CONVERSATION_STARTED_FROM_URL = 'FACTDriftChatConversationV2.conversationCreatedFromUrl',
  TEAM_PARTICIPATED_TEAM_ID = 'DriftChatTeamUsersOnlyParticipants.teamId',
  USER_PARTICIPATED_USER_ID = 'DriftChatConversationParticipants.userId',
  DAY_OF_WEEK = 'FACTDriftChatConversationV2.dayOfWeek',
  HOUR_OF_DAY = 'FACTDriftChatConversationV2.hourOfDay',
  INITIAL_ROUTED_IN_TEAM_ID = 'DriftChatTeamUsersOnlyFirstRouted.teamId',
  INITIAL_ROUTED_IN_USER = 'DriftChatAppUsersOnlyFirstRouted.userId',
  END_USER_COUNTRY_CODE = 'DriftChatEndUsers.geoCountryCode',
  CQL_SCORE = 'DriftChatEndUsers.cqlScore',
  CONVERSATION_HAD_TEAMMATE_ROUTED_IN = 'DriftChatConversationRouting.hasTeammateRoutedIn',
  CONVERSATION_ROUTING_OUTCOME = 'DriftChatConversationRouting.routingOutcome',
  TEAMMATES_UNAVAILABLE = 'DriftChatConversationRouting.teammatesWereUnavailable',
  TEAMMATE_RESPONDED = 'DriftChatConversationRouting.hasTeammateResponded',
  TEAMMATE_ROUTED_IN_TO_RESPONDED_WITHIN60S = 'DriftChatConversationRouting.hasRespondedWithin60Seconds',
  TEAMMATE_RESPONDED_LATE = 'DriftChatConversationRouting.hasMissedAndSomeoneRespondedLate',
  IS_DEAD_END_CONVERSATION = 'DriftChatConversationRouting.isDeadEnd',
  EMAIL_CAPTURED = 'FACTDriftChatConversationV2.hasEmailCaptured',
  PHONE_CAPTURED = 'FACTDriftChatConversationV2.hasPhoneCaptured',
  MEETING_BOOKED = 'FACTDriftChatConversationV2.hasMeetingBooked',
  PLAYBOOK_METRICS_IS_END_USER_MOBILE = 'DriftChatBlendedPlaybookMetrics.isEnduserMobile',
  LANGUAGE_DETECTED = 'FACTDriftChatConversationV2.detectedLanguage',
  GEO_COUNTRY_CODE = 'DriftChatBlendedPlaybookMetrics.geoCountryCode',
  AI_TOPIC_TRIGGERED = 'DriftChatConversationTopics.topicId',
  EXCLUDED_AI_TOPIC_TRIGGERED = 'DriftChatTopicsPerformanceExcludedTopics.topicId',
  HAS_ROUTED_AND_EVERYONE_MISSED = 'DriftChatConversationRouting.hasRoutedAndEveryoneMissed',
  TIME_TO_FIRST_RESPONSE_S = 'DriftChatConversationRouting.timeToFirstResponseS',
  CONVERSATION_ROUTED = 'DriftChatConversationRouting.conversationId',
  CONVERSATION_HAS_UNRESPONSIVE_FALLBACK = 'DriftChatConversationRouting.hasUnresponsiveFallback',
  CHAT_INTERACTIONS_MESSAGE_BODY = 'DriftChatInteractions.messageBody',
  END_USER_COMPANY_NAME = 'DriftChatEndUsers.companyName',
  END_USER_EMAIL = 'DriftChatEndUsers.email',
  HAS_CALENDAR_DROP = 'FACTDriftChatConversationV2.hasCalendarDrop',
  PLAYBOOK_TYPE = 'DriftChatPlaybooks.reportType',
  NODE_TRIGGERED = 'DriftChatSkillExecutions.skillType',
  URL_QUERY_PARAMETERS_PARAM_KEY_VALUE = 'DriftChatConversationUrlParameters.paramValue',
  MEETING_STATUS = 'DriftChatSchedulingEvents.status',
  IS_END_USER_MOBILE = 'FACTDriftChatConversationV2.isEnduserMobile',
  ROI_OPPORTUNITY_TYPE = 'DriftChatOpportunityOverview.opportunityType',
  ROI_OPPORTUNITY_AMOUNT = 'DriftChatOpportunityOverview.opportunityAmount',
  ROI_COMPANY = 'DriftChatOpportunityOverview.companyName',
  ROI_CLOSED_DATE = 'DriftChatOpportunityOverview.opportunityClosedAtWithZone',
  ROI_IS_INFLUENCED = 'DriftChatOpportunityOverview.isInfluenced',
  ROI_IS_SOURCED = 'DriftChatOpportunityOverview.isSourced',
  ROI_DAYS_IN_CYCLE = 'DriftChatOpportunityOverview.opportunityDaysInCycle',
  ROI_CONTACT_COUNT = 'DriftChatOpportunityOverview.contactCount',
  ROI_OPPORTUNITY_STAGE = 'DriftChatOpportunityOverview.opportunityStage',
  BUYER_SENTIMENT = 'DriftChatConversationSentiment.overallBuyerSentiment',
  CSAT_RATING = 'DriftChatConversationRatings.ratingValue',
  TOPIC_DETECTED_ID = 'DriftChatConversationTopicPredictions.topicId',
  OPPORTUNITY_NAME = 'DriftChatOpportunityOverview.opportunityName',
  SITE_CONCIERGE_IS_END_USER_MOBILE = 'DriftSiteConcierge.isMobile',
  SCENARIO_TRIGGERED = 'DriftChatSkillExecutions.scenarioId',
  GPT_ENABLED_PLAYBOOK_ID = 'DriftChatPlaybooks.playbookId',
  BIONIC_MESSAGE_CATEGORY_ID = 'DriftChatBionicMessageCategoryRatings.categoryId',
  BIONIC_MESSAGE_SCENARIO_ID = 'DriftChatBionicMessageCategoryRatings.scenarioId',
}

/**  Enum of specific dimension member strings that are used for key value filters.*/
export enum CubeFilterKeyValueDimensions {
  URL_QUERY_PARAMETERS_PARAM_KEY = 'DriftChatConversationUrlParameters.paramKey',
  URL_QUERY_PARAMETERS_PARAM_VALUE = 'DriftChatConversationUrlParameters.paramValue',
}

/**  A Dictionary that contains the corresponding CubeFilterKeyValueDimensions for each CubeFilterDimensions that is meant to be key-value enabled.  */
export const KeyValueFilterDict: Record<
  string,
  { key: CubeFilterKeyValueDimensions; value: CubeFilterKeyValueDimensions }
> = {
  [CubeFilterDimensions.URL_QUERY_PARAMETERS_PARAM_KEY_VALUE]: {
    key: CubeFilterKeyValueDimensions.URL_QUERY_PARAMETERS_PARAM_KEY,
    value: CubeFilterKeyValueDimensions.URL_QUERY_PARAMETERS_PARAM_VALUE,
  },
}

export const HumanizedCubeFilterDimensions: Record<
  CubeFilterDimensions,
  string
> = {
  [CubeFilterDimensions.CONVERSATION_PLAYBOOK_ID]: 'Playbook',
  [CubeFilterDimensions.CONVERSATION_PARTICIPANT_STATUS]: 'Participant type',
  [CubeFilterDimensions.CONVERSATION_CLASSIFICATION_ID]: 'Lead stage',
  [CubeFilterDimensions.CONVERSATION_INBOX_ID]: 'Inbox',
  [CubeFilterDimensions.CONVERSATION_TAG_NAME]: 'Chat tag',
  [CubeFilterDimensions.CONVERSATION_STARTED_FROM_URL]: 'Chat started from URL',
  [CubeFilterDimensions.TEAM_PARTICIPATED_TEAM_ID]: 'Team participated',
  [CubeFilterDimensions.USER_PARTICIPATED_USER_ID]: 'Teammate participated',
  [CubeFilterDimensions.DAY_OF_WEEK]: 'Day of week',
  [CubeFilterDimensions.HOUR_OF_DAY]: 'Hour of day',
  [CubeFilterDimensions.INITIAL_ROUTED_IN_USER]: 'First routed-in teammate',
  [CubeFilterDimensions.INITIAL_ROUTED_IN_TEAM_ID]: 'First routed-in team',
  [CubeFilterDimensions.LANGUAGE_DETECTED]: 'Language',
  [CubeFilterDimensions.END_USER_COUNTRY_CODE]: 'Region',
  [CubeFilterDimensions.CQL_SCORE]: 'CQL score',
  [CubeFilterDimensions.CONVERSATION_HAD_TEAMMATE_ROUTED_IN]:
    'Teammate routed in',
  [CubeFilterDimensions.CONVERSATION_ROUTING_OUTCOME]: 'Routing outcome',
  [CubeFilterDimensions.TEAMMATES_UNAVAILABLE]: 'Teammates unavailable',
  [CubeFilterDimensions.TEAMMATE_RESPONDED]: 'Teammate responded',
  [CubeFilterDimensions.TEAMMATE_ROUTED_IN_TO_RESPONDED_WITHIN60S]:
    'Teammate responded within 60s',
  [CubeFilterDimensions.TEAMMATE_RESPONDED_LATE]: 'Teammate responded late',
  [CubeFilterDimensions.IS_DEAD_END_CONVERSATION]: 'Is dead end',
  [CubeFilterDimensions.EMAIL_CAPTURED]: 'Email captured',
  [CubeFilterDimensions.PHONE_CAPTURED]: 'Phone captured',
  [CubeFilterDimensions.MEETING_BOOKED]: 'Meeting booked',
  [CubeFilterDimensions.PLAYBOOK_METRICS_IS_END_USER_MOBILE]: 'Is mobile user',
  [CubeFilterDimensions.GEO_COUNTRY_CODE]: 'Region',
  [CubeFilterDimensions.AI_TOPIC_TRIGGERED]: 'AI topic triggered',
  [CubeFilterDimensions.EXCLUDED_AI_TOPIC_TRIGGERED]:
    'Basic AI topic triggered',
  [CubeFilterDimensions.HAS_ROUTED_AND_EVERYONE_MISSED]:
    'Has routed and everyone missed',
  [CubeFilterDimensions.TIME_TO_FIRST_RESPONSE_S]:
    'Time to first response in seconds',
  [CubeFilterDimensions.CONVERSATION_ROUTED]: 'Conversation routed',
  [CubeFilterDimensions.CHAT_INTERACTIONS_MESSAGE_BODY]: 'Words or phrases',
  [CubeFilterDimensions.END_USER_COMPANY_NAME]: 'Company Name',
  [CubeFilterDimensions.END_USER_EMAIL]: 'Email',
  [CubeFilterDimensions.HAS_CALENDAR_DROP]: 'Has calendar drop',
  [CubeFilterDimensions.PLAYBOOK_TYPE]: 'Playbook type',
  [CubeFilterDimensions.NODE_TRIGGERED]: 'Node triggered',
  [CubeFilterDimensions.SCENARIO_TRIGGERED]: 'Triggered scenario',
  [CubeFilterDimensions.CONVERSATION_HAS_UNRESPONSIVE_FALLBACK]:
    'Has unresponsive fallback',
  [CubeFilterDimensions.URL_QUERY_PARAMETERS_PARAM_KEY_VALUE]:
    'Chat started from URL query param',
  [CubeFilterDimensions.MEETING_STATUS]: 'Meeting outcome',
  [CubeFilterDimensions.IS_END_USER_MOBILE]: 'Is mobile user',
  [CubeFilterDimensions.ROI_OPPORTUNITY_TYPE]: 'Opportunity type',
  [CubeFilterDimensions.ROI_OPPORTUNITY_AMOUNT]: 'Amount',
  [CubeFilterDimensions.ROI_COMPANY]: 'Company name',
  [CubeFilterDimensions.ROI_CLOSED_DATE]: 'Closed date',
  [CubeFilterDimensions.ROI_DAYS_IN_CYCLE]: 'Days in cycle',
  [CubeFilterDimensions.ROI_IS_INFLUENCED]: 'Is influenced',
  [CubeFilterDimensions.ROI_IS_SOURCED]: 'Is sourced',
  [CubeFilterDimensions.ROI_CONTACT_COUNT]: 'Contact count',
  [CubeFilterDimensions.ROI_OPPORTUNITY_STAGE]: 'Opportunity stage',
  [CubeFilterDimensions.BUYER_SENTIMENT]: 'Visitor sentiment',
  [CubeFilterDimensions.CSAT_RATING]: 'CSAT rating',
  [CubeFilterDimensions.TOPIC_DETECTED_ID]: 'Topic detected',
  [CubeFilterDimensions.OPPORTUNITY_NAME]: 'Opportunity Name',
  [CubeFilterDimensions.SITE_CONCIERGE_IS_END_USER_MOBILE]: 'Is mobile user',
  [CubeFilterDimensions.GPT_ENABLED_PLAYBOOK_ID]: 'Playbook',
  [CubeFilterDimensions.BIONIC_MESSAGE_CATEGORY_ID]: 'Category',
  [CubeFilterDimensions.BIONIC_MESSAGE_SCENARIO_ID]: 'Triggered Scenario',
}

export enum CubeOperator {
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  SET = 'set',
  NOT_SET = 'notSet',
  CONTAINS = 'contains',
  DOES_NOT_CONTAIN = 'notContains',
  GREATER_THAN = 'gt',
  LESS_THAN_OR_EQUAL = 'lte',
}

// CubeOperator to display string
export const HumanizedCubeOperators: Record<CubeOperator, string> = {
  [CubeOperator.EQUALS]: 'is',
  [CubeOperator.NOT_EQUALS]: 'is not',
  [CubeOperator.SET]: 'is defined',
  [CubeOperator.NOT_SET]: 'is not defined',
  [CubeOperator.CONTAINS]: 'contains',
  [CubeOperator.DOES_NOT_CONTAIN]: 'does not contain',
  [CubeOperator.GREATER_THAN]: '>',
  [CubeOperator.LESS_THAN_OR_EQUAL]: '<=',
}

export enum ConversationParticipantStatus {
  BOT_ONLY = 'BOT_ONLY',
  PERSON_ONLY = 'PERSON_ONLY',
  MIXED = 'MIXED',
}

export type OperatorSelectOption = {
  label: string
  value: CubeOperator
}

export enum GroupNames {
  CHAT_DETAILS = 'Chat details ',
  CHAT_VISITOR = 'Chat visitor',
  CHAT_OUTCOMES = 'Chat outcomes',
  PLAYBOOKS = 'Playbooks',
  ROUTING = 'Routing',
  LIVE_CHAT = 'Live chat',
  PIPELINE_OUTCOMES = 'Pipeline outcomes',
  OPPORTUNIES = 'Opportunities',
}

export const groupOrder = [
  '',
  GroupNames.CHAT_DETAILS,
  GroupNames.CHAT_VISITOR,
  GroupNames.CHAT_OUTCOMES,
  GroupNames.PLAYBOOKS,
  GroupNames.ROUTING,
  GroupNames.LIVE_CHAT,
  GroupNames.PIPELINE_OUTCOMES,
]
